import { Button } from "@whitespace/components";
import * as defaultStyles from "@whitespace/gatsby-plugin-smorgasbord-aptus-booking/src/components/ConfirmationScreen.module.css";
import AptusContext from "@whitespace/gatsby-plugin-smorgasbord-aptus-booking/src/contexts/aptusContext";
import {
  ErrorMessage,
  Loading,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import clsx from "clsx";
import { parseISO } from "date-fns";
import PropTypes from "prop-types";
import React, { useContext, useState, useRef, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

import { cancelVerifiedBooking } from "../../../aptus-booking/booking";

ConfirmationScreen.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  confirmation: PropTypes.shape({
    apartmentId: PropTypes.string.isRequired,
    booking: PropTypes.object.isRequired,
  }).isRequired,
};

export default function ConfirmationScreen({
  styles = defaultStyles,
  className,
  confirmation,
}) {
  const { t } = useTranslation();
  const { apiPath, setBookings, setBookedPass } = useContext(AptusContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const pending = useRef(false);
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  const { apartmentId, booking } = confirmation;

  async function handleCancelBooking() {
    if (pending.current) return;
    pending.current = true;
    setLoading(true);
    setError(null);
    try {
      await cancelVerifiedBooking({
        apiPath,
        apartmentId,
        bookingId: booking.bookingId,
      });
      if (!active.current) return;
      setBookings((bookings) =>
        bookings.filter(
          (item) => String(item.bookingId) !== String(booking.bookingId),
        ),
      );
      setBookedPass(null);
    } catch {
      if (active.current)
        setError(
          "Avbokningen kunde inte bekräftas. Kontrollera dina bokningar innan du försöker igen.",
        );
    } finally {
      pending.current = false;
      if (active.current) setLoading(false);
    }
  }

  if (loading) return <Loading />;
  if (error) return <ErrorMessage error={error} />;

  const groupName = booking.groupName;
  const startTime = parseISO(booking.startTime);
  const date = startTime.toLocaleDateString("sv", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  const timeOptions = { hour: "2-digit", minute: "2-digit" };
  const timeRange = `${startTime.toLocaleTimeString(
    "sv",
    timeOptions,
  )}–${parseISO(booking.stopTime).toLocaleTimeString("sv", timeOptions)}`;

  return (
    <div className={clsx(styles.component, className)}>
      <p>
        <Trans i18nKey="bookingConfirmationMessage">
          You have booked <strong>{{ groupName }}</strong> on{" "}
          <strong>{{ date }}</strong> between <strong>{{ timeRange }}</strong>.
        </Trans>
      </p>
      <Button onClick={handleCancelBooking}>{t("cancel")}</Button>
    </div>
  );
}
